import { Tooltip } from "@xola/ui-kit";
import pluralize from "pluralize";
import React from "react";
import { Product } from "types";
import { useResource } from "../../hooks/useResource";
import { NoTranslate } from "../Common/NoTranslate";
import { SecondaryButton } from "../Common/SecondaryButton";
import { SelectionWithName } from "../Dashboard/Filters/ListFilter";

interface ItemSummaryProps {
    label: string;
    collection: string[];
    value: SelectionWithName;
    onClick: () => void;
}

export const ItemSummary = ({ label, collection, value, onClick }: ItemSummaryProps) => {
    return (
        <SecondaryButton className="font-normal" onClick={onClick}>
            <Content label={label} collection={collection} selection={value} />
        </SecondaryButton>
    );
};

interface ContentProps {
    label: string;
    collection: string[];
    selection: SelectionWithName;
}

const Content = ({ label, collection, selection }: ContentProps) => {
    const count = selection.selected.length;
    if (count === 0 || selection.all) {
        return <span className="truncate">All {pluralize(label, 2)}</span>;
    }

    return (
        <Tooltip
            content={
                <div className="space-y-1 py-1">
                    {selection.selected.map((item) => (
                        <TooltipContent key={item.id} item={item} collection={collection} />
                    ))}
                </div>
            }
        >
            <span className="px-1">
                <var data-var="count">{count}</var>
            </span>
            <span className="ml-1">{pluralize(label, count)}</span>
        </Tooltip>
    );
};

interface TooltipContentProps {
    item: SelectionWithName["selected"][any];
    collection: string[];
}

const TooltipContent = ({ item, collection }: TooltipContentProps) => {
    const { data } = useResource<Product>([...collection, item.id], null, { enabled: !item.name });
    return <NoTranslate as="div">{item.name ?? data?.name ?? item.id}</NoTranslate>;
};
